// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3rI9v","title":"Images90_title__2lBjs","images":"Images90_images__3coF-"};